import { Link } from '@tanstack/react-router';
import { Button } from '@tempo-io/sui-button';
import { Edit, ExternalLink } from '@tempo-io/sui-icons';

interface LinkButtonProps {
  url: string;
  description?: string;
  isEditable?: boolean;
  onClick?: () => void;
  id?: string;
}

export const LinkButton = ({
  url,
  description,
  isEditable = false,
  onClick,
  id,
}: LinkButtonProps) => {
  const displayText = description || url || 'Link';

  if (!isEditable) {
    return (
      <Link
        to={url || '#'}
        target="_blank"
        id={id}
        className="flex items-center gap-2"
        data-testid="link-button-link"
      >
        <Button size="sm" variant="secondary" aria-label={`Open link to ${displayText}`}>
          <span data-testid="link-button-text">{displayText}</span>
        </Button>
        <ExternalLink />
      </Link>
    );
  }

  return (
    <Button
      size="sm"
      variant="secondary"
      onClick={onClick}
      className="flex items-center gap-1"
      data-testid="link-button"
    >
      <Edit />
      <span data-testid="link-button-text">{displayText}</span>
    </Button>
  );
};
